import { render } from "./TextBrowseItem.vue?vue&type=template&id=5cfac2ba&scoped=true"
import script from "./TextBrowseItem.vue?vue&type=script&lang=js"
export * from "./TextBrowseItem.vue?vue&type=script&lang=js"

import "./TextBrowseItem.vue?vue&type=style&index=0&id=5cfac2ba&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src827224769/src/frontend-broker/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cfac2ba"]])

export default __exports__